import React, { useMemo, useState } from 'react';
import { Box, Paper, Typography, Stack, Tabs, Tab } from '@mui/material';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import TimelineIcon from '@mui/icons-material/Timeline';
import { useAuth } from '../contexts/AuthContext';
import ContratosModuloHeader from '../components/contratos/ContratosModuloHeader';
import VisaoRestritaBanner from '../components/VisaoRestritaBanner';
import ComparativoServicosUnidadesPanel from '../components/contratos/ComparativoServicosUnidadesPanel';
import LinhaDoTempoAditivosPanel from '../components/contratos/LinhaDoTempoAditivosPanel';

function TabPanel({ children, value, index }) {
  if (value !== index) return null;
  return <Box sx={{ pt: 2 }}>{children}</Box>;
}

export default function ContratosAnaliseComparativaPage() {
  const { user, rbacRole, fiscalSetor } = useAuth();
  const scopeOpts = useMemo(() => ({ user, rbacRole, fiscalSetor }), [user, rbacRole, fiscalSetor]);
  const [tab, setTab] = useState(0);

  return (
    <Box sx={{ p: 2 }}>
      <VisaoRestritaBanner />
      <Paper
        elevation={0}
        sx={{
          p: 3,
          mb: 2,
          borderRadius: 3,
          background: 'linear-gradient(135deg, rgba(25,118,210,0.08) 0%, rgba(66,165,245,0.08) 100%)',
          border: '1px solid rgba(25,118,210,0.15)',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            gap: 2,
          }}
        >
          <Box>
            <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 0.5 }}>
              <CompareArrowsIcon color="primary" />
              <Typography variant="h5" fontWeight={700} color="primary">
                Análise Comparativa de Contratos
              </Typography>
            </Stack>
            <Typography variant="body2" color="text.secondary">
              Compare contratos entre unidades ou analise a trilha completa de um contrato com projeção de reajuste.
            </Typography>
          </Box>
          <ContratosModuloHeader />
        </Box>
      </Paper>

      <Paper
        elevation={0}
        sx={{
          borderRadius: 3,
          border: '1px solid rgba(21,101,192,0.12)',
          backgroundColor: 'rgba(255,255,255,0.92)',
          px: 2,
        }}
      >
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab
            icon={<CompareArrowsIcon fontSize="small" />}
            iconPosition="start"
            label="Comparativo entre unidades"
            sx={{ textTransform: 'none', fontWeight: 600 }}
          />
          <Tab
            icon={<TimelineIcon fontSize="small" />}
            iconPosition="start"
            label="Trilha do contrato"
            sx={{ textTransform: 'none', fontWeight: 600 }}
          />
        </Tabs>

        <TabPanel value={tab} index={0}>
          <ComparativoServicosUnidadesPanel scopeOpts={scopeOpts} />
        </TabPanel>
        <TabPanel value={tab} index={1}>
          <LinhaDoTempoAditivosPanel scopeOpts={scopeOpts} />
        </TabPanel>
      </Paper>
    </Box>
  );
}
